module.exports = __webpack_public_path__ + "img/167.072c4ede.jpg";